<template>
  <div class="about">
    <div>
      <div
        class="header-main web"
        :style="{
          backgroundImage:
            'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
        }"
      >
        <ul class="link-list">
          <div class="header-img">
            <img
              src="../assets/img/emotibot_logo.c18e704.png"
              class="logo"
              alt=""
            />
          </div>
          <li class="">
            <span class="" @click="downloadIndex(2)">首页</span>
            <!---->
          </li>
          <li class="" >
            <span class="" @click="downloadIndex(1)">软件下载</span>
          </li>
          <li class="active">
            <span class="active">关于我们</span>
          </li>
        </ul>
      </div>
      <div
        class="wrap"
        :style="{
          backgroundImage:
            'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
        }"
      >
        <div class="wrap-nav">
          <img
            src="../assets/img/emotibot_logo.c18e704.png"
            alt=""
            style="width: 128px; padding-top: 30px; height: 128px"
          />
          <span> <i class="el-icon-menu" @click="openList()"></i></span>
        </div>
        <ul class="wrap-nav-list" :style="menuShowFlag">
          <li @click="downloadIndex(2)">
            <span>首页</span>
            <!---->
          </li>
          <li>
            <span>软件下载</span>
            <!---->
          </li>
          <li @click="downloadIndex(1)">
            <span>关于我们</span>
            <!---->
          </li>
        </ul>
      </div>
    </div>

    <div class="banner">
      <div class="web web-box img-contact">
        <img src="../assets/images/banner/home_banner_web_BG6.png" alt="" />
        <div class="banner-content banner-content-contact">
          <p class="desc-large-contact">Optimus Prime RPA</p>
          <p class="desc-normal-contact">
            Optimus Prime RPA
            AI流程机器人技术，是一个使用软件技术将手工工作自动化的流程优化数字化服务方案，是B端乃至C端提高工效的有效手段。机器人的作用是代替人工完成：
          </p>
          <p class="product-desc-title">
            高重复 <br />标准化 <br />标准化<br />
            大批量<br />
            预判预测<br />
          </p>
        </div>
      </div>
      <div class="wrap"></div>
    </div>
    <div class="introduce">
      <div class="content-center">
        <p class="com-title">公司简介</p>
        <div class="desc-bg">
          <span class="intro-desc">
            上海霁宇智能信息科技有限公司是一家以数字化员工为核心的高科技AI产品公司，提供自研RPA产品OPTIMUSPRIME
            RPA
            公司以“产品卓越，规范管理，持续创新”为核心价值观。致力于为各行业客户提供智能的RPA
            机器人产品与解决方案，通过RPA赋能，持续为客户创造高价值，
            助力企业实现“人人事事自动化”的降本增效的大方向。
          </span>
          <span class="intro-desc"></span>
        </div>
      </div>
    </div>
    <div class="content-center tech web">
      <div class="bg-circle"></div>
      <div class="title-box">
        <p class="title-first">联系我们</p>
      </div>
      <ul class="flex-item">
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/c1.png" alt="" />
            <div>
              <p class="title-second">商务合作</p>
              <p class="line"></p>
              <p class="content">postmaster@op-rpa.com</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/j2.png" alt="" />
            <div>
              <p class="title-second">技术支持</p>
              <p class="line"></p>
              <p class="content">postmaster@op-rpa.com</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/tz4.png" alt="" />
            <div>
              <p class="title-second">投资意向</p>
              <p class="line"></p>
              <p class="content">postmaster@op-rpa.com</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
        <li class="">
          <div class="show-item">
            <img src="../assets/images/icon/jr3.png" alt="" />
            <div>
              <p class="title-second">加入我们</p>
              <p class="line"></p>
              <p class="content">liuxinyu@op-rpa.com</p>
            </div>
          </div>
          <div class="active-item"></div>
        </li>
      </ul>
    </div>
    <div class="wrap contact-type">
      <p class="com-title">联系我们</p>
      <ul>
        <li>
          <img src="../assets/images/icon/c1.png" alt="" />
          <div>
            <p class="p-title">商务合作</p>
            <p class="p-desc">liuxinyu@op-rpa.com</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon/j2.png" alt="" />
          <div>
            <p class="p-title">技术支持</p>
            <p class="p-desc">liuxinyu@op-rpa.com</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon/tz4.png" alt="" />
          <div>
            <p class="p-title">投资意向</p>
            <p class="p-desc">liuxinyu@op-rpa.com</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon/jr3.png" alt="" />
          <div>
            <p class="p-title">加入我们</p>
            <p class="p-desc">liuxinyu@op-rpa.com</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="content-center">
      <p class="form-title">
        如果您对霁宇服务与产品感兴趣，欢迎留下联络资料，我们将尽快与您联系。
      </p>
      <div class="form-content">
        <label
          ><span>姓名*</span><input type="text" placeholder="请输入您的姓名"
        /></label>
        <label
          ><span>公司全称*</span
          ><input type="text" placeholder="请输入您的公司全称"
        /></label>
        <label
          ><span>联络电话*</span
          ><input type="text" placeholder="请输入您的联系电话"
        /></label>
        <label
          ><span>E-mail*</span><input type="text" placeholder="请输入您的邮箱"
        /></label>
        <div class="form-checkbox-item">
          <p class="form-title-inner">您是如何得知霁宇的？（多选）</p>
          <div>
            <div
              role="group"
              aria-label="checkbox-group"
              class="el-checkbox-group"
            >
              <label role="checkbox" class="el-checkbox"
                ><span aria-checked="mixed" class="el-checkbox__input"
                  ><span class="el-checkbox__inner"></span
                  ><input
                    type="checkbox"
                    aria-hidden="true"
                    name="type"
                    class="el-checkbox__original"
                    value="媒体报道" /></span
                ><span class="el-checkbox__label">媒体报道</span></label
              >
              <label role="checkbox" class="el-checkbox"
                ><span aria-checked="mixed" class="el-checkbox__input"
                  ><span class="el-checkbox__inner"></span
                  ><input
                    type="checkbox"
                    aria-hidden="true"
                    name="type"
                    class="el-checkbox__original"
                    value="网络搜索" /></span
                ><span class="el-checkbox__label">网络搜索</span></label
              >
              <label role="checkbox" class="el-checkbox"
                ><span aria-checked="mixed" class="el-checkbox__input"
                  ><span class="el-checkbox__inner"></span
                  ><input
                    type="checkbox"
                    aria-hidden="true"
                    name="type"
                    class="el-checkbox__original"
                    value="朋友介绍" /></span
                ><span class="el-checkbox__label">朋友介绍</span></label
              >
              <label role="checkbox" class="el-checkbox"
                ><span aria-checked="mixed" class="el-checkbox__input"
                  ><span class="el-checkbox__inner"></span
                  ><input
                    type="checkbox"
                    aria-hidden="true"
                    name="type"
                    class="el-checkbox__original"
                    value="行业会议与展会" /></span
                ><span class="el-checkbox__label">行业会议与展会</span></label
              >
              <label role="checkbox" class="el-checkbox"
                ><span aria-checked="mixed" class="el-checkbox__input"
                  ><span class="el-checkbox__inner"></span
                  ><input
                    type="checkbox"
                    aria-hidden="true"
                    name="type"
                    class="el-checkbox__original"
                    value="其他" /></span
                ><span class="el-checkbox__label">其他</span></label
              >
            </div>
          </div>
        </div>
        <p class="form-title-inner form-title-textarea">
          服务需求／问询内容（必填）*
        </p>
        <div class="textarea-box">
          <textarea
            placeholder="请简短的描述下您的需求"
            class="requirements"
          ></textarea>
        </div>
        <div><span class="sub-btn">发送</span></div>
        <div class="declare">
          <p class="declare-p-1">声明：</p>
          <p>您所输入的资料，本公司会遵循隐私政策来处理：</p>
          <p>您留下的个人资料，除回复您的询问时使用外，不会用于其他目的。</p>
          <p>
            如果您要询问个人资料，或修改及删除等，可与我们公司联络（postmaster@op-rpa.com），我们将在核对您的信息后进行处理。
          </p>
        </div>
      </div>
    </div>
    <div
      class="footer-main"
      :style="{
        backgroundImage:
          'url(' + require('../assets/img/footer_bg.24952d8.png') + ')',
      }"
    >
      <div class="content-center web">
        <div class="footer-box">
          <div class="footer-left">
            <ul class="item-box">
              <li class="footer-item1">
                <span
                  >加入我们：liuxinyu@jiyu-ai.com<br />
                  商务合作：chentianyu@jiyu-ai.com<br />
                  技术支持：liqiangjian@jiyu-ai.com<br />
                   联系电话：13916027955<br />
                  公司地址：上海市浦东新区龙阳路2277号永达国际大厦9楼903室
                </span>
              </li>
              <li data-v-2f6d6da0="" class="footer-item1">
                <span
                  >联系电话：13916027955<br />
                  公司地址：辽宁省铁岭市银州区柴河街道卧龙馨园1幢1-12(二层)
                </span>
              </li>
              <li data-v-2f6d6da0="" class="footer-item1">
                <span
                >联系电话：13916027955<br />
                  公司地址：河南省驻马店市新蔡县弥陀寺乡林场西街派出所北100米40号
                </span>
              </li>
            </ul>
          </div>
          <ul data-v-2f6d6da0="" class="footer-right">
            <li data-v-2f6d6da0="">
              <img
                data-v-2f6d6da0=""
                src="../assets/images/code/wechat.jpg"
                alt=""
              />
              <p data-v-2f6d6da0="">霁宇智能公众号</p>
            </li>
          </ul>
        </div>
        <div class="copy-right">
          <span
            >Copyright © 2026 上海霁宇智能信息科技有限公司 All Rights Reserved ·
            <a
              href="http://www.beian.miit.gov.cn"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </span>
          <span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015630"
              target="_blank"
              rel="noopener noreferrer"
              >沪ICP备2025152194号-2</a
            ></span
          >
        </div>
      </div>

      <p class="wrap copy-text">
        Copyright © 2026 上海霁宇智能信息科技有限公司 All Rights Reserved ·
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShowFlag: "display: none;",
      menuShowIndex: 0,
    };
  },
  methods: {
    openList() {
      if (this.menuShowIndex == 0) {
        this.menuShowFlag = "display: block;";
        this.menuShowIndex = 1;
      } else {
        this.menuShowFlag = "display: none;";
        this.menuShowIndex = 0;
      }
    },
    downloadIndex(id) {
      if (id == 1) {
        //直接跳转
        this.$router.push({ path: "/product" });
      } else {
        this.$router.push({ path: "/" });
      }
    },
  },
};
</script>
